import ResourceIIIStatus from "./ResourceIIIStatus";
import { SummaryCompleteProps } from "../../app/models/SummaryComplete";
import { Grid } from "@mui/material";
import ChildrenBookDevelopement from "./ResourceIIIChildrenBooks";
import AddaBook from "./ResourceIIIAddNewBook";
import { useCallback, useEffect, useState } from "react";
import { useAppSelector } from "../../app/store/configureStore";
import agent from "../../app/api/agent";
import LoadingSpinner from "../../app/common/LoadingSpinner";

export default function CompetencyIIIResourceCollection() {
  const [summaryCompleteProps, setSummaryCompleteProps] =
    useState<SummaryCompleteProps>({
      title: "My Resource Collection III ",
      percent: "",
      header:
        "Competency III: To support social and emotional development and to provide positive guidance",
      description: `Here you are going to create a bibliography of 10 developmentally appropriate children's books you use with families to support the development of their children. Click "Add Book Entry" to add the required information per book.`,
    });

  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAppSelector((state) => state.account);

  const fetchData = useCallback(async () => {
    try {
      if (user?.portfolioId) {
        const compData = await agent.Progress.GetCompentencyResultsByType(
          user.portfolioId,
          "RCIII"
        );
        setSummaryCompleteProps((prevSummaryCompleteProps) => ({
          ...prevSummaryCompleteProps,
          percent: compData.resourceProgress + "%",
        }));
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }, [user?.portfolioId]);

  const RecallData = () => {
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <Grid container p={2} mb={2}>
        <ResourceIIIStatus {...summaryCompleteProps} />
        <ChildrenBookDevelopement />
        <AddaBook RecallData={RecallData} />
      </Grid>
    </>
  );
}
